import Cookies from 'js-cookie'

export default {


	// Local Storage
	getLocalItem: function(key) {
		if (typeof(Storage) !== 'undefined') {
			return localStorage.getItem(key);
		}
		return false;
	},
	removeLocalItem: function(key) {
		if (typeof(Storage) !== 'undefined') {
			localStorage.removeItem(key);
			return true;
		}
		return false;
	},
	setLocalItem: function(key, value) {
		if (typeof(Storage) !== 'undefined') {
			localStorage.setItem(key, value);
			return true;
		}
		return false;
	},

	// Session Storage
	getSessionItem: function(key) {
		if (typeof(Storage) !== 'undefined') {
			return sessionStorage.getItem(key);
		}
		return false;
	},
	removeSessionItem: function(key) {
		if (typeof(Storage) !== 'undefined') {
			sessionStorage.removeItem(key);
			return true;
		}
		return false;
	},
	setSessionItem: function(key, value) {
		if (typeof(Storage) !== 'undefined') {
			sessionStorage.setItem(key, value);
			return true;
		}
		return false;
	},

	setSessionCookie(key, value) {
		Cookies.set(key, value)
	},

	getCookie(key) {
		return Cookies.get(key)
	}
}
